"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class GaiaMessage extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gaiaMessage';
        this._role = initParams.role;
        this._content = initParams.content;
        this._conversationId = initParams.conversation_id;
        this._createdAt = initParams.created_at;
    }
    set role(value) {
        console.error('Do not set objects this way');
    }
    get role() {
        return this._role;
    }
    set content(value) {
        console.error('Do not set objects this way');
    }
    get content() {
        return this._content;
    }
    set conversationId(value) {
        console.error('Do not set objects this way');
    }
    get conversationId() {
        return this._conversationId;
    }
    set createdAt(value) {
        console.error('Do not set objects this way');
    }
    get createdAt() {
        return this._createdAt;
    }
}
exports.default = GaiaMessage;
//# sourceMappingURL=gaiaMessage.js.map